export default __webpack_public_path__ + "static/media/02.83dfd89f.jpg";